import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Resource } from '../../models/resource';

@Component({
  selector: 'app-choir-resource-dialog',
  templateUrl: './choir-resource-dialog.component.html',
  styleUrls: ['./choir-resource-dialog.component.scss'], // Updated to .scss
  standalone: false  
})
export class ChoirResourceDialogComponent {
  editForm: FormGroup;
  viewMode: boolean;
  selectedFile: File | null = null; // Add a property to store the selected file

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ChoirResourceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { resource: Resource | null; viewMode: boolean }
  ) {
    this.viewMode = data.viewMode;
    this.editForm = this.fb.group({
      id: [data.resource?.id || 0],
      name: [data.resource?.name || ''],
      path: [data.resource?.path || ''],
      resourceEntity: ['Choir', { disabled: true }], // Fixed value for resourceEntity
      resourceType: [data.resource?.resourceType || ''],
      isHyperlink: [data.resource?.isHyperlink || false]      
    });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input?.files?.length) {
      this.selectedFile = input.files[0];
      console.log('Selected file:', this.selectedFile); // Debugging log
    }
  }

  saveChanges(): void {
    if (this.editForm.valid) {
      const resourceData = {
        ...this.editForm.value,
        file: this.selectedFile // Include the selected file in the data
      };
      this.dialogRef.close(resourceData);
    }
  }

  closeDialog(): void {
    this.dialogRef.close(null);
  }

    onIsHyperlinkChange(): void {
    if (this.editForm.get('isHyperlink')?.value) {
      this.selectedFile = null; // Clear the selected file if "Is Hyperlink" is true
      console.log('File selector disabled because "Is Hyperlink" is true.');
    }
  }
}
